// Utility functions for time formatting
// Formats time to HH:MM:SS format everywhere in the application
// ✅ ПОПРАВЕНО: Користи toLocaleString со Europe/Skopje timezone за правилна конверзија

import logger from './logger';

/**
 * Format timestamp to DD.MM.YYYY HH:MM:SS format (Macedonia timezone)
 * @param {string|Date|number} timestamp - UTC timestamp од базата
 * @returns {string} - Форматиран датум и време во македонско време
 */
export const formatDateTimeToHHMMSS = (timestamp) => {
  if (!timestamp) return '--:--:--';
  
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (isNaN(date.getTime())) return '--:--:--';
  
  // 🆕 ПРОВЕРИ ДАЛИ TIMESTAMP Е ВАЛИДЕН (не е 1970 или пред 2000)
  const minValidTimestamp = new Date('2000-01-01').getTime();
  if (date.getTime() < minValidTimestamp) {
    logger.warn('⚠️ formatDateTimeToHHMMSS: Невалиден timestamp (пред 2000):', timestamp);
    return '--:--:--';
  }
  
  // Користи toLocaleString со Europe/Skopje timezone
  // JavaScript автоматски ја детектира летно/зимско време
  return date.toLocaleString('mk-MK', {
    timeZone: 'Europe/Skopje',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).replace(',', ''); // "29.11.2025, 12:00:00" -> "29.11.2025 12:00:00"
};

/**
 * Format timestamp to HH:MM:SS format (Macedonia timezone)
 * @param {string|Date|number} timestamp - UTC timestamp од базата
 * @returns {string} - Форматирано време во HH:MM:SS формат
 */
export const formatTimeToHHMMSS = (timestamp) => {
  if (!timestamp) return '--:--:--';
  
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (isNaN(date.getTime())) return '--:--:--';
  
  return date.toLocaleTimeString('mk-MK', {
    timeZone: 'Europe/Skopje',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

/**
 * Format timestamp to relative time with HH:MM:SS for recent times
 * @param {string|Date|number} timestamp - UTC timestamp од базата
 * @returns {string} - Форматирано релативно време
 */
export const formatRelativeTimeWithHHMMSS = (timestamp) => {
  if (!timestamp) return '--:--:--';
  
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (isNaN(date.getTime())) return '--:--:--';
  
  const now = new Date();
  const diffInMinutes = Math.floor((now - date) / (1000 * 60));

  if (diffInMinutes < 1) {
    return 'сега';
  } else if (diffInMinutes < 60) {
    return `пред ${diffInMinutes} мин`;
  } else if (diffInMinutes < 1440) {
    const hours = Math.floor(diffInMinutes / 60);
    return `пред ${hours} ч`;
  } else {
    // For older dates, show full date and time with HH:MM:SS
    return formatDateTimeToHHMMSS(timestamp);
  }
};

/**
 * Format timestamp to time only (HH:MM:SS) for display in lists
 * @param {string|Date|number} timestamp - UTC timestamp од базата
 * @returns {string} - Форматирано време само
 */
export const formatTimeOnly = (timestamp) => {
  if (!timestamp) return '--:--:--';
  
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (isNaN(date.getTime())) return '--:--:--';
  
  return formatTimeToHHMMSS(timestamp);
};
